{
  "en": {
    "employee": {
      "actions": {
        "accessProjects": "Manage projects access",
        "cancel": "Undo",
        "changeProfilePicture": "Change Profile Picture",
        "download": "Download",
        "new": "Team Member",
        "profilePictureFormat": "Should be at least 300x300px",
        "save": "Save",
        "searchEmployee": "Search Team Member",
        "sendinvitation": "Create and send Invitation",
        "submit": "Save",
        "undoChanges": "Undo"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Once per day (around noon)",
          "hourly": "Every hour",
          "twice_daily": "Twice per day (morning/noon)",
          "weekly": "Once per week (Monday noon)"
        },
        "first_name": "First name",
        "language": "Language",
        "last_name": "Last name",
        "phone_landline": "Landline number",
        "phone_mobile": "Mobile number",
        "profession": "Job title",
        "role": "Access rights",
        "signature_html": "Conversation Signature",
        "status": "Status",
        "title": "Title"
      },
      "billing": {
        "contact_us": "Contact us",
        "contact_us_message": "Hi, I would like to change the package of {client_name}.",
        "gigabytes": "{amount} GB",
        "in_use": "/ {total} in use",
        "manage_members": "Manage members",
        "package": "Package",
        "package_help_mup": "Looking for extra projects or storage, or want to change the plan?",
        "package_help_sup": "Looking for extra projects, seats or storage, or want to change the plan?",
        "plan_renamed": "We've introduced new plans, so the name shown here may not match your current subscription. Contact us to learn more about the new plans.",
        "projects": "Projects",
        "projects_available": "All projects in use | 1 project available | {count} projects available",
        "seats": "Seats",
        "seats_active": "/ {total} active",
        "seats_package": "No seats in your package | 1 seat in your package | {count} seats in your package",
        "seats_paying": "+ 1 extra paying seat | + {count} extra paying seats",
        "storage": "Storage",
        "storage_available": "{amount} GB available",
        "storage_total": "/ {amount} GB",
        "units": "Units",
        "units_available": "All units in use | 1 unit available | {count} units available"
      },
      "integrations": {
        "hide_details": "Hide details",
        "last_synced_at": "Last synced at: {time}",
        "show_details": "Show details"
      },
      "labels": {
        "all_projects": "All projects",
        "confirmPasswordReset": "An email has been sent with a link to reset your password, please check your inbox. Contact us if you experience any problems.",
        "disabled": {
          "access": "We will grant all employees access to the platform from the moment the last overdue invoice is paid.",
          "contact": "Contact us",
          "overdue": "We noticed your last invoice is long overdue. We revoked access for all employees on this platform. Partners and customers will still be able to access their data.",
          "title": "Your account has been disabled!"
        },
        "display": "Display",
        "filters": "Filters",
        "generalNotifications": "Notify me about",
        "has_access_to": "Has access to",
        "information": "Profile Information",
        "informationNotificationsEmail": "Receive an overview via e-mail, including only notifications you haven't seen yet on the platform.",
        "informationNotificationsPlatform": "Receive all notifications in your personal overview on the top right of the screen",
        "informationNotificationsTitle": "Decide what kind of notifications you want to receive and how",
        "its_you!": "It's you!",
        "maintainerAccess": "Access granted per project.",
        "name": "Name",
        "onPlatform": "On Platform",
        "ownerAccess": "Access to all projects and content, plus billing and team management.",
        "password": "Password",
        "permissions": "Access rights for",
        "permissionsOwnerOnly": "As a Project Maintainer you cannot perform this action. Please ask a {client_name} team member with Owner role to do this for you.",
        "projectMaintains": "{first_name} has access to the following projects:",
        "projectMaintainsAdd": "To grant access, select a project and add {first_name} as a Project Maintainer under the Information feature.",
        "projectMaintainsNone": "doesn't have access to any projects.",
        "projectNotifications": "For project",
        "search_by_name_or_email": "Search by name or email",
        "show_signature": "Show signature",
        "signature_active": "Signature active",
        "signature_info": "This signature will be added to replies sent to customers and partners.",
        "sorting": "Sorting",
        "viaEmail": "Via Email"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Accessible",
          "description": "Changes are saved automatically",
          "not_accessible": "Not accessible",
          "title": "Update project accessibility for {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Maintainer",
        "owner": "Owner"
      },
      "team": {
        "actions": {
          "activate": "Activate",
          "cancel_invitation": "Cancel invitation",
          "deactivate": "Deactivate",
          "invite": "Invite",
          "make_maintainer": "Make maintainer",
          "make_owner": "Make owner",
          "remove": "Remove from team"
        },
        "dialogs": {
          "activate_body": "{name} gets full access to the platform again.",
          "activate_body_pending": "{name} moves back to Pending, and becomes active when they log in with their invitation.",
          "activate_body_seat": "{name} gets full access to the platform again. This uses one seat.",
          "activate_confirm": "Activate",
          "activate_title": "Activate {name}?",
          "cancel_invitation_body": "{name} can no longer join with the invitation they received.",
          "cancel_invitation_confirm": "Cancel invitation",
          "cancel_invitation_title": "Cancel invitation?",
          "contact_us": "Contact us",
          "contact_us_message": "Hi, I would like to add more seats for {client_name}.",
          "deactivate_body": "{name} keeps their account but loses access to the platform.",
          "deactivate_body_seat": "{name} keeps their account but loses access to the platform. This frees up one seat.",
          "deactivate_confirm": "Deactivate",
          "deactivate_title": "Deactivate {name}?",
          "demote_body": "{name} loses access to all projects until you give them access, and can no longer manage billing or the team.",
          "demote_confirm": "Make maintainer",
          "demote_title": "Make {name} a maintainer?",
          "owner_wall_banner": "Your organization must always have at least one active owner.",
          "owner_wall_body_deactivate": "Reactivate or promote another owner before you deactivate {name}.",
          "owner_wall_body_demote": "Reactivate or promote another owner before you change the role of {name}.",
          "owner_wall_body_remove": "Reactivate or promote another owner before you remove {name}.",
          "owner_wall_title": "Action blocked",
          "promote_body": "{name} gets access to all projects and can manage billing and the team.",
          "promote_confirm": "Make owner",
          "promote_title": "Make {name} an owner?",
          "remove_body": "{name} loses access and leaves the members list. You can't undo this, but you can invite them again later.",
          "remove_body_seat": "{name} loses access and leaves the members list. You can't undo this, but you can invite them again later. This frees up one seat.",
          "remove_confirm": "Remove",
          "remove_title": "Remove {name} from the team?",
          "seats_full_banner": "Your only seat is in use. | All {total} seats are in use.",
          "seats_full_body": "Deactivate an active member to make a seat available, or contact us to add more seats.",
          "seats_full_invite_body": "You need an available seat to invite someone. Deactivate an active member, or contact us to add more seats.",
          "seats_full_invite_title": "You're out of seats",
          "seats_full_title": "No seats available"
        },
        "invite_incomplete": "Fill in first name, last name and email to send the invitation.",
        "invite_note": "They become active as soon as they create an account and log in.",
        "invite_note_seats": "Once they create an account and log in they become active, using your last available seat. | Once they create an account and log in they become active, using one of your {count} available seats.",
        "invite_sent": "Invitation sent",
        "invited_at": "Invited: {when}",
        "last_active": "Last active",
        "manage_in_billing": "Manage in Billing",
        "resend_wait": "You can resend the invitation 15 minutes after the last one.",
        "role": "Role",
        "seat_states": "Seat states",
        "seat_states_help": {
          "active": "Full access, uses one seat. Owners and maintainers.",
          "inactive": "Account exists, no platform access. Frees up the seat.",
          "pending": "Invited, no account yet. Doesn't use a seat."
        },
        "seat_usage": "Seat usage",
        "seats_available": "No seats available — deactivate a member or contact us | 1 seat available | {count} seats available",
        "seats_rule": "Only an owner can activate a member, and only while a seat is available.",
        "seats_total": "/ {total} active seat | / {total} active seats",
        "statuses": {
          "active": "Active",
          "inactive": "Inactive",
          "pending": "Pending"
        }
      },
      "toasts": {
        "create": "Team member has been created",
        "update": "Team member has been updated"
      },
      "validation": {
        "emailTaken": "Email address has already been used",
        "mustBeEmailAddress": "Valid email address required",
        "needFirstName": "First name required",
        "needLastName": "Last name required",
        "requireEmailAddress": "Email required",
        "role": "Select access rights"
      }
    }
  }
}
